//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('offDutyCodes', {
//        templateUrl: 'views/components/views/offDutyCodes/offDutyCodes.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'economyService', function (stateService, economyService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//        	vm.model = {
//                itemsListOffDutyCodes: []
//        	};

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            let loadOffDutyCodes = function () {
//                economyService.listOffDutyCodes().then(function (list) {
//                    angular.copy(list, vm.model.itemsListOffDutyCodes);
//                });
//            };

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'offdutycode':
//                        go({ offdutycode_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadOffDutyCodes();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
